import { ref } from 'vue';

const events = ref({});

const emit = (eventName, data) => {
  if (events.value[eventName]) {
    events.value[eventName].forEach((callback) => callback(data));
  }
};

const on = (eventName, callback) => {
  if (!events.value[eventName]) {
    events.value[eventName] = [];
  }
  events.value[eventName].push(callback);

  return () => {
    const index = events.value[eventName].indexOf(callback);
    if (index !== -1) {
      events.value[eventName].splice(index, 1);
    }
  };
};

const off = (eventName, callback) => {
  if (events.value[eventName]) {
    const index = events.value[eventName].indexOf(callback);
    if (index !== -1) {
      events.value[eventName].splice(index, 1);
    }
  }
};

const once = (eventName, callback) => {
  const handler = (data) => {
    callback(data);
    off(eventName, handler);
  };

  on(eventName, handler);
};

export { emit, on, off, once };
